/* global Offline */
import Env from 'lib/Env';

import { reportBackOnline } from '../activities/actions/searchlightActions';
import { throwCustomAquaError } from '../activities/components/GlobalErrorHandler/actions';
import { ERROR_STRINGS } from '../activities/components/GlobalErrorHandler/constants';

let throwOfflineErrorTimeout;
let wentOfflineTimestamp = 0;

export default (store, gameId) => {
  Offline.on('down', () => {
    wentOfflineTimestamp = Date.now();
    const duration = ((Env.isDevEnv) && AQUA_GLOBALS.QA.offlineDuration)
      ? AQUA_GLOBALS.QA.offlineDuration
      : 3000;
    throwOfflineErrorTimeout = setTimeout(() => {
      store.dispatch(throwCustomAquaError({
        titleText: ERROR_STRINGS.uhOh,
        secondaryText: ERROR_STRINGS.checkYourInternetConnection,
        showGamesButton: false,
        showHomeButton: true,
        forceLogout: false,
        errorMessage: 'Internet connection went offline',
      }));
    }, duration);
  });

  Offline.on('up', () => {
    // If there's a went offline timestamp, calc the amount of time that was spent
    // offline, in milliseconds
    const timeSpentOffline = wentOfflineTimestamp !== 0
      ? Date.now() - wentOfflineTimestamp
      : undefined;
    wentOfflineTimestamp = 0; // clear timestamp
    clearTimeout(throwOfflineErrorTimeout);
    store.dispatch(reportBackOnline(gameId, { timeSpentOffline }));
  });
};
